import { VendorFinancialsVendor } from '../../components/Vendor';
import { usePageTitle } from '../../hooks';

export function Financials() {
  usePageTitle('vendor:sections.financials');
  return <VendorFinancialsVendor />;
}
